var $ = global.jQuery = global.$;
require('rangeslider.js');
var Field = require('./Field');

/**
 * Generates a basic custom select box
 * @class
 * @extends Field
 */
var RangeSlider = Field.extend(
  /** @lends CustomSelect.prototype */
  {
  /**
   * Initialises the widget
   * @private
   */
  init: function() {
    var self = this;
    this._super();
    this.$valueHolder = this.$el.find('[data-range-value]');
    this.$input.rangeslider({
      polyfill: false
    });
    self.updateValue();
    this.$input.on('input change', function(event) {
      self.updateValue();
    });
  },
  updateValue: function() {
    this.$valueHolder.text(this.$input.val());
  }
});

module.exports = RangeSlider;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/RangeSlider.js
// module id = 119
// module chunks = 0